// Accordion controller — multiple-open by default.
// To force single-open behavior: <div class="accordion" data-multi="false">...</div>
(function () {
  const ACC_SELECTOR = ".accordion";
  const BUTTON_SELECTOR = ".accordion-button";

  const accordions = Array.from(document.querySelectorAll(ACC_SELECTOR));
  if (!accordions.length) return;

  accordions.forEach(initAccordion);

  function initAccordion(root) {
    // Default: allow multiple open. Set data-multi="false" to enforce single-open.
    const allowMultiple = root.dataset.multi !== "false";
    const buttons = Array.from(root.querySelectorAll(BUTTON_SELECTOR));

    buttons.forEach((btn) => {
      const panel = document.getElementById(btn.getAttribute("aria-controls"));
      if (!panel) return;

      // initial sync
      if (btn.getAttribute("aria-expanded") === "true") {
        panel.setAttribute("aria-hidden", "false");
        panel.classList.add("open");
        panel.style.maxHeight = "none";
      } else {
        panel.setAttribute("aria-hidden", "true");
        panel.classList.remove("open");
        panel.style.maxHeight = "0px";
      }

      btn.addEventListener("click", () => toggle(btn, panel));
      btn.addEventListener("keydown", (e) => onKey(e, btn, buttons));

      panel.addEventListener("transitionend", (ev) => {
        if (
          !["max-height", "padding-top", "padding-bottom"].includes(
            ev.propertyName
          )
        )
          return;
        if (btn.getAttribute("aria-expanded") === "true") {
          panel.style.maxHeight = "none";
        } else {
          panel.style.maxHeight = "0px";
        }
        panel.classList.remove("animating");
      });

      const imgs = Array.from(panel.querySelectorAll("img"));
      imgs.forEach((img) => {
        if (img.complete) return;
        img.addEventListener("load", () => {
          if (
            btn.getAttribute("aria-expanded") === "true" &&
            panel.style.maxHeight !== "none"
          ) {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      });
    });

    let resizeTimer;
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        buttons.forEach((btn) => {
          const panel = document.getElementById(
            btn.getAttribute("aria-controls")
          );
          if (!panel) return;
          if (
            btn.getAttribute("aria-expanded") === "true" &&
            panel.style.maxHeight !== "none"
          ) {
            panel.style.maxHeight = panel.scrollHeight + "px";
            requestAnimationFrame(() => {
              panel.style.maxHeight = "none";
            });
          }
        });
      }, 120);
    });

    function toggle(btn, panel) {
      const isOpen = btn.getAttribute("aria-expanded") === "true";
      if (isOpen) {
        close(btn, panel);
      } else {
        if (!allowMultiple) {
          buttons.forEach((otherBtn) => {
            if (otherBtn === btn) return;
            if (otherBtn.getAttribute("aria-expanded") === "true") {
              const otherPanel = document.getElementById(
                otherBtn.getAttribute("aria-controls")
              );
              if (otherPanel) close(otherBtn, otherPanel);
            }
          });
        }
        open(btn, panel);
      }
    }

    function open(btn, panel) {
      btn.setAttribute("aria-expanded", "true");
      panel.setAttribute("aria-hidden", "false");
      panel.classList.add("animating", "open");
      const h = panel.scrollHeight;
      panel.style.maxHeight = h + "px";
    }

    function close(btn, panel) {
      btn.setAttribute("aria-expanded", "false");
      panel.setAttribute("aria-hidden", "true");
      panel.style.maxHeight = panel.scrollHeight + "px";
      // force reflow
      // eslint-disable-next-line no-unused-expressions
      panel.offsetHeight;
      panel.classList.add("animating");
      panel.classList.remove("open");
      panel.style.maxHeight = "0px";
    }

    function onKey(e, btn, allButtons) {
      const KEY = e.key;
      const idx = allButtons.indexOf(btn);
      if (KEY === "Enter" || KEY === " ") {
        e.preventDefault();
        toggle(btn, document.getElementById(btn.getAttribute("aria-controls")));
        return;
      }

      if (
        [
          "ArrowDown",
          "ArrowRight",
          "ArrowUp",
          "ArrowLeft",
          "Home",
          "End",
        ].includes(KEY)
      ) {
        e.preventDefault();
        let nextIndex;
        switch (KEY) {
          case "ArrowDown":
          case "ArrowRight":
            nextIndex = (idx + 1) % allButtons.length;
            break;
          case "ArrowUp":
          case "ArrowLeft":
            nextIndex = (idx - 1 + allButtons.length) % allButtons.length;
            break;
          case "Home":
            nextIndex = 0;
            break;
          case "End":
            nextIndex = allButtons.length - 1;
            break;
        }
        allButtons[nextIndex].focus();
      }
    }
  }
})();
